import { Navigate } from 'react-router-dom';

const adminLinks = [
  {
    label: 'Manage Products',
    href: '/admin/dashboard/products',
    icon: <span className="text-4xl mb-2">📦</span>,
  },
  {
    label: 'Manage Blog Posts',
    href: '/admin/dashboard/blogs',
    icon: <span className="text-4xl mb-2">📝</span>,
  },
  {
    label: 'Manage Hero Slider',
    href: '/admin/dashboard/heroSlider',
    icon: <span className="text-4xl mb-2">🖼️</span>,
  },
  {
    label: 'Manage Home Text',
    href: '/admin/dashboard/home-content',
    icon: <span className="text-4xl mb-2">🏠</span>,
  }
];

const AdminDashboard = () => {
  const token = localStorage.getItem('adminAuth');
  if (!token) return <Navigate to="/admin" replace />;

  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] p-4">
      <h1 className="text-3xl font-bold mb-8 text-center">Admin Dashboard</h1>
      <div className="flex flex-col md:flex-row gap-8">
        {adminLinks.map((link) => (
          <a
            key={link.href}
            href={link.href}
            className="flex flex-col items-center bg-white rounded-2xl shadow-md hover:shadow-lg transition-shadow border border-gray-100 p-8 w-64 text-center group"
          >
            {link.icon}
            <span className="text-lg font-semibold group-hover:underline">{link.label}</span>
          </a>
        ))}
      </div>
    </div>
  );
};

export default AdminDashboard;
